import React, { useState } from "react";
import JdoodleEmbed from "./components/JdoodleEmbed";

function App() {
  const [activeTab, setActiveTab] = useState("python");

  const embeds = {
    python: "https://www.jdoodle.com/embed/v1/cfddd558c05ee809",
    java: "https://www.jdoodle.com/embed/v1/7d864b806588c13d",
    c: "https://www.jdoodle.com/embed/v1/2797e763a7e2d5de",
    cpp: "https://www.jdoodle.com/embed/v1/e882f5e794939184",
    SQlite: "https://www.jdoodle.com/embed/v1/16b8b16b61daf593",
  };

  return (
    <div style={{ padding: "20px" }}>
      <h1>Multi-Language JDoodle Editor</h1>

      {/* Tabs */}
      <div style={{ marginTop: "20px", display: "flex", gap: "10px" }}>
        {Object.keys(embeds).map((lang) => (
          <button
            key={lang}
            onClick={() => setActiveTab(lang)}
            style={{
              padding: "10px 15px",
              borderRadius: "6px",
              border: activeTab === lang ? "2px solid blue" : "1px solid grey",
              background: activeTab === lang ? "#dbeafe" : "#f3f4f6",
              cursor: "pointer",
            }}
          >
            {lang.toUpperCase()}
          </button>
        ))}
      </div>

      {/* Selected Embed */}
      <div style={{ marginTop: "20px" }}>
        <JdoodleEmbed url={embeds[activeTab]} />
      </div>
    </div>
  );
}

export default App;
